export default "__VITE_ASSET__d1522f83__"